import { render, staticRenderFns } from "./YzNeedDraft.vue?vue&type=template&id=28b9b22c&scoped=true"
import script from "./YzNeedDraft.vue?vue&type=script&lang=js"
export * from "./YzNeedDraft.vue?vue&type=script&lang=js"
import style0 from "./YzNeedDraft.vue?vue&type=style&index=0&id=28b9b22c&prod&lang=css"
import style1 from "./YzNeedDraft.vue?vue&type=style&index=1&id=28b9b22c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b9b22c",
  null
  
)

export default component.exports